import React, { Component } from "react";
import ReeValidate from 'ree-validate';
import { connect } from 'react-redux';
import { checkUserSubscribed } from '../store/actions/auth'
import { convertReadbleFormat } from './../helpers';

const $ = window.$;
class FollowMeExistUserModal extends Component {

  constructor(props) {
    super(props)
    this.validator = new ReeValidate({
      email: 'required|email'
    })
    this.state = {
      formData: {
        email: '',
      },
      formErrors: this.validator.errors,
      class: '#alreadyFitbanx'
    }
  }

  handleSubmit = e => {
    e.preventDefault()
    const { removeError, checkUserSubscribed, match: { params: { referralCode } } } = this.props
    removeError();
    const { formData } = this.state
    const { errors } = this.validator
    this.validator.validateAll(formData)
      .then(success => {
        if (success) {
          checkUserSubscribed({
            email: formData.email,
            referenceCode: referralCode
          }).then((res) => {
            $(this.state.class).modal('hide');
            if (res.isSubscribeUser) {
              this.props.showSuccessMessage(true);
            } else {
              this.props.openPaymentForm(formData.email, referralCode, true);
            }
          }).catch((err) => {
            if (err.isAccountSet) {
              $(this.state.class).modal('hide');
              this.props.openPaymentForm('', '', false);
            }
          })
        } else {
          this.setState({ formErrors: errors })
        }
      })
  }

  componentDidMount() {
    const { errors } = this.validator
    const { removeError } = this.props
    $(this.state.class).on('hidden.bs.modal', () => {
      this.setState({
        formData: {
          email: ''
        }
      }, () => {
        errors.clear();
        removeError();
      });
    })
  }

  handleChange = e => {
    const name = e.target.name
    const value = e.target.value
    const { errors } = this.validator
    errors.remove(name)
    this.setState({ formData: { ...this.state.formData, [name]: value } })
    this.validator.validate(name, value)
      .then(() => {
        this.setState({ formErrors: errors })
      })
  }

  render() {

    const { formData, formErrors } = this.state
    const { errors } = this.props

    return (
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <button type="button" className="close" data-dismiss="modal">&times;</button>
            <h3>I am already a Fitbanx user.</h3>
          </div>
          <div style={{ 'padding': '50px' }} className="modal-body">
            {errors && errors.message && <div className="alert alert-danger">{errors.message}</div>}
            <h3>Enter your Fitbanx username (hint- your email address).</h3>
            <form onSubmit={this.handleSubmit} noValidate>
              <div className="form-group">
                <input type="email"
                  className="form-control"
                  id="email"
                  placeholder="Enter email address (Fitbanx username)"
                  name="email"
                  onChange={this.handleChange}
                  required
                  value={formData.email} />
                {formErrors.has('email') &&
                  <span className="error">{convertReadbleFormat(formErrors.first('email'))}</span>
                }
              </div>
              <div className="row">
                <div className="col-md-6">
           
                </div>
              </div>
              <button style={{ 'width': '100%' }} type="submit" className="btn circle btn-light border btn-md">Finish</button>
            </form>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-default" data-dismiss="modal">Close</button>
          </div>
        </div>

      </div>

    )
  }
}

function mapStateToProps(state, ownProps) {
  return {}
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    checkUserSubscribed: (data) => {
      return dispatch(checkUserSubscribed(data));
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(FollowMeExistUserModal);




// WEBPACK FOOTER //
// ./src/modals/followMeExistingUser.js